export const tabs: string[] = ['Goals', 'Achievements'];
